import axios from 'axios'
import config from './config'

export default {
  getSignedURL (file, bucket, folder) {
    let payload = {
      bucketName: bucket,
      filePath: folder + file.name.replaceAll(/\s/g, "_"),
      contentType: file.type
    }
    return axios.post(config.CLOUDDRIVE_API_ENDPOINT + "getSignedUrl", payload)
      .then((res) => {
        return Promise.resolve(res.data.url || '/')        
      })
      .catch((err) => {
        console.log(err)
        return Promise.reject('/')
      })
  }
}